import { InvoiceLineType } from '@features/invoices/enums/invoiceLineType'

import { CommonInvoiceLineFieldProps } from '../../types/commonInvoiceLineFieldProps'
import { InvoiceDescriptionLineFields } from './elements/InvoiceDescriptionLineFields'
import { InvoiceRowLineFields } from './elements/InvoiceRowLineFields'
import { InvoiceSubtotalLineFields } from './elements/InvoiceSubtotalLineFields'

interface InvoiceLineFieldsProps extends CommonInvoiceLineFieldProps {
  lineType: InvoiceLineType
}

export const InvoiceLineFields = ({ lineIndex, lineType }: InvoiceLineFieldsProps) => {
  if (lineType === InvoiceLineType.Row) {
    return <InvoiceRowLineFields lineIndex={lineIndex} />
  }

  if (lineType === InvoiceLineType.Description) {
    return <InvoiceDescriptionLineFields lineIndex={lineIndex} />
  }

  if (lineType === InvoiceLineType.Subtotal) {
    return <InvoiceSubtotalLineFields lineIndex={lineIndex} />
  }

  return null
}
